export default __webpack_public_path__ + "clipboard.3067bec8.png";